<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import { todoComputed, todoMethods } from '@/state/helpers'
import { mapGetters } from 'vuex'
import McBadge from '@/components/McBadge'
/**
 * Starter component
 */
export default {
  page: {
    title: 'Master',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McBadge,
  },
  data() {
    return {}
  },

  computed: {
    ...todoComputed,
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
      isNewModule: 'identity/isNewModule',
      isNewSubmodule: 'identity/isNewSubmodule',
    }),
    /**
     * Total no. of records
     */

    title() {
      return this.$t('master.dataMaster')
    },
  },

  methods: {
    ...todoMethods,
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="card mc-card mc-card-front">
      <div class="card-body">
        <b-tabs content-class="p-3 text-muted">
          <b-tab active class="border-0">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home"></i>
              </span>
              <span class="d-none d-sm-inline-block">{{ $t('master.dataMaster') }}</span>
            </template>
            <b-row class="mc-card__list">
              <b-col
                md="6"
                v-if="hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete'])"
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Master Customer' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_people"> </i>
                  <McBadge
                    v-if="
                      isNewSubmodule('d6a-default-md-pelanggan')
                    "
                    :text="$t('global.new')"
                    variant="danger"
                    size="medium"
                    type="pill"
                    class="text-uppercase float-end"
                  ></McBadge>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('master.pelanggan') }}</h4>
                    <p>{{ $t('master.textPelanggan') }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col
                md="6"
                v-if="hasAccessAll(['vms:create', 'vms:read', 'vms:update', 'vms:delete'])"
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Master Vendor' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_person"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('master.vendor.title') }}</h4>
                    <p>{{ $t('master.vendor.subtitle') }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col
                md="6"
                v-if="hasAccessAll(['vms:create', 'vms:read', 'vms:update', 'vms:delete'])"
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Master Vendor Contract' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_folder"></i>
                  <span class="float-end">
                    <McBadge
                      v-if="isNewSubmodule('vms-main')"
                      :text="$t('global.new')"
                      variant="danger"
                      size="medium"
                      type="pill"
                      class="text-uppercase float-end"
                    ></McBadge>
                  </span>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('master.vendorContract.title') }}</h4>
                    <p>{{ $t('master.vendorContract.subtitle') }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col
                md="6"
                v-if="hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete'])"
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Master Product' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_cube"></i>
                  <McBadge
                    v-if="isNewModule('tms-base-module')"
                    :text="$t('global.new')"
                    variant="danger"
                    size="medium"
                    type="pill"
                    class="text-uppercase float-end"
                  ></McBadge>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('master.product.title') }}</h4>
                    <p>{{ $t('master.product.subtitle') }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col md="6" v-if="hasAccessAll(['vehicles:read', 'd1a-default-mdkendaraan:read'])">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Master Fleet' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_car"></i>
                  <McBadge
                    v-if="
                      isNewSubmodule('d1a-default-mdkendaraan')
                    "
                    :text="$t('global.new')"
                    variant="danger"
                    size="medium"
                    type="pill"
                    class="text-uppercase float-end"
                  ></McBadge>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('master.kendaraan') }}</h4>
                    <p>{{ $t('master.textKendaraan') }}</p>
                  </div>
                </b-button>
              </b-col>

              <b-col md="6" v-if="hasAccessAll(['devices:read', 'd2a-default-mdpelacak:read'])">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Master Tracking' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_radio"></i>
                  <McBadge
                    v-if="
                      isNewSubmodule('d2a-default-mdpelacak')
                    "
                    :text="$t('global.new')"
                    variant="danger"
                    size="medium"
                    type="pill"
                    class="text-uppercase float-end"
                  ></McBadge>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('master.pelacak') }}</h4>
                    <p>{{ $t('master.textPelacak') }}</p>
                  </div>
                </b-button>
              </b-col>

              <b-col md="6" v-if="hasAccessAll(['geofences:read', 'd3a-default-mdalamat:read'])">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Master Address' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_pin"></i>
                  <McBadge
                    v-if="
                      isNewSubmodule('d3a-default-mdalamat')
                    "
                    :text="$t('global.new')"
                    variant="danger"
                    size="medium"
                    type="pill"
                    class="text-uppercase float-end"
                  ></McBadge>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('master.alamat') }}</h4>
                    <p>{{ $t('master.textAlamat') }}</p>
                  </div>
                </b-button>
              </b-col>

              <b-col md="6" v-if="hasAccessAll(['users:read', 'd4a-default-mdpengguna:read'])">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Master User' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_person"></i>
                  <McBadge
                    v-if="
                      isNewSubmodule('d4a-default-mdpengguna')
                    "
                    :text="$t('global.new')"
                    variant="danger"
                    size="medium"
                    type="pill"
                    class="text-uppercase float-end"
                  ></McBadge>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('master.pengguna') }}</h4>
                    <p>{{ $t('master.textPengguna') }}</p>
                  </div>
                </b-button>
              </b-col>

              <b-col md="6" v-if="hasAccessAll(['users:read', 'd5a-default-mdkaryawan:read'])">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Master Employee' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_people"> </i>
                  <McBadge
                    v-if="
                      isNewSubmodule('d5a-default-mdkaryawan')
                    "
                    :text="$t('global.new')"
                    variant="danger"
                    size="medium"
                    type="pill"
                    class="text-uppercase float-end"
                  ></McBadge>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('master.karyawan') }}</h4>
                    <p>{{ $t('master.textKaryawan') }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col md="6" v-if="hasAccessAll(['katalog_sparepart:read'])">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Master Service' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_settings"> </i>
                  <McBadge
                    v-if="
                      isNewSubmodule('d8a-md-katalogsukucadang')
                    "
                    :text="$t('global.new')"
                    variant="danger"
                    size="medium"
                    type="pill"
                    class="text-uppercase float-end"
                  ></McBadge>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('master.maintenance') }}</h4>
                    <p>{{ $t('master.textMaintenance') }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col md="6" v-if="hasAccessAll(['geofences:read', 'd7a-default-md-route:read'])">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Master Route' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_pin-history"> </i>
                  <McBadge
                    v-if="
                      isNewSubmodule('d7a-default-md-route:read')
                    "
                    :text="$t('global.new')"
                    variant="danger"
                    size="medium"
                    type="pill"
                    class="text-uppercase float-end"
                  ></McBadge>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('master.rute') }}</h4>
                    <p>{{ $t('master.textRute') }}</p>
                  </div>
                </b-button>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>
